import { CatchedError } from '@/core/classes/CatchedError.class'
import { createToast, ToastContent, ToastOptions, ToastType } from 'mosha-vue-toastify'

// types
export type NotificationContent = ToastContent
export type NotificationOptions = ToastOptions
export type NotificationType = ToastType

// constants
export const NOTIFICATION_DURATION = 15000
export const NOTIFICATION_POSITION = 'top-right'

export default function () {
    function notify({
        title,
        description,
        type,
    }: {
        title: string
        description?: string
        type: NotificationType
    }) {
        const content: NotificationContent = {
            title,
            description,
        }

        const options: NotificationOptions = {
            type,
            position: NOTIFICATION_POSITION,
            timeout: NOTIFICATION_DURATION,
        }

        createToast(content, options)
    }

    function notifyError({ error, title }: { error: unknown; title: string }) {
        if (Array.isArray(error)) {
            error.forEach((iterated_error: string) => {
                notify({ title, description: iterated_error, type: 'danger' })
            })

            return
        }

        if (error instanceof CatchedError) {
            notify({
                title,
                description: error.message,
                type: 'danger',
            })

            return
        }
    }

    return { notify, notifyError }
}
